export const headerName = {
  add: "Добавить результат обследования",
  view: "Просмотр результата обследования",
};

export const examinationResultData = {
  ownerLeName: {
    key: "ownerLeName",
    label: "Наименование ЮЛ эксплуатанта базы",
    type: "selectSearch",
    options: [],
  },
  section: {
    key: "section",
    label: "Участок",
    type: "text",
    disabled: true,
  },
  ownerAdress: {
    key: "ownerAddress",
    label: "Адрес эксплуатанта базы",
    type: "text",
    disabled: true,
  },
  ownerPhone: {
    key: "ownerPhone",
    label: "Телефон эксплуатанта базы",
    type: "text",
    disabled: true,
  },
  location: {
    key: "location",
    label: "Местонахождение базы",
    type: "text",
    disabled: true,
  },
  phone1: {
    key: "phone1",
    label: "Основной телефон",
    type: "text",
    disabled: true,
  },
  phone2: {
    key: "phone2",
    label: "Дополнительный телефон",
    type: "text",
    disabled: true,
  },
  responFio: {
    key: "responFio",
    label: "ФИО ответственного за эксплуатацию базы",
    type: "text",
    disabled: true,
  },
  responPosition: {
    key: "responPosition",
    label: "Должность ответственного за эксплуатацию базы",
    type: "text",
    disabled: true,
  },
  examinationDate: {
    key: "examinationDate",
    label: "Дата последнего обследования",
    type: "date",
    required: true,
  },
  checkStatus: {
    key: "checkStatus",
    label: "Результат последнего обследования",
    type: "selectSearch",
    isSearchable: false,
    required: true,
    options: [],
  },
};

export const examinationResultDataView = {
  ownerLeName: {
    key: "ownerLeName",
    label: "Наименование ЮЛ эксплуатанта базы",
    type: "text",
  },
  section: {
    key: "section",
    label: "Участок",
    type: "text",
    disabled: true,
  },
  ownerAdress: {
    key: "ownerAddress",
    label: "Адрес эксплуатанта базы",
    type: "text",
    disabled: true,
  },
  ownerPhone: {
    key: "ownerPhone",
    label: "Телефон эксплуатанта базы",
    type: "text",
    disabled: true,
  },
  location: {
    key: "location",
    label: "Местонахождение базы",
    type: "text",
    disabled: true,
  },
  phone1: {
    key: "phone1",
    label: "Основной телефон",
    type: "text",
    disabled: true,
  },
  phone2: {
    key: "phone2",
    label: "Дополнительный телефон",
    type: "text",
    disabled: true,
  },
  responFio: {
    key: "responFio",
    label: "ФИО ответственного за эксплуатацию базы",
    type: "text",
    disabled: true,
  },
  responPosition: {
    key: "responPosition",
    label: "Должность ответственного за эксплуатацию базы",
    type: "text",
    disabled: true,
  },
  examinationDate: {
    key: "examinationDate",
    label: "Дата последнего обследования",
    type: "text",
    required: true,
  },
  checkStatus: {
    key: "checkStatus",
    label: "Результат последнего обследования",
    type: "text",
    required: true,
  },
};

export const setDataForExaminationResult = async (prop, field) => {
  if (prop) {
    switch (field) {
      case "ownerLeName": {
        examinationResultData.ownerLeName.options = prop.map((item) => {
          return {
            label: item.ownerLeName,
            value: item.parkId,
            key: "ownerLeName",
          };
        });
        break;
      }
      case "checkStatus": {
        return (examinationResultData.checkStatus.options = prop);
      }
    }
  }
};

export const getDataExaminationResultModal = () => examinationResultData;
export const getDataExaminationResultViewModal = () => examinationResultDataView;

export const customStyles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    border: "1px solid #BC865399",
    borderRadius: "6px",
    boxShadow: state.isFocused ? "0 0 0 .25rem #BC865380" : "",
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    color: "#233E5A",
    padding: "4px 0",
    marginTop: "6px",
    "&:hover": {
      border: "1px solid #BC865399",
    },
  }),
  input: (baseStyles) => ({
    ...baseStyles,
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    color: "#233E5A",
  }),
  placeholder: (baseStyles) => ({
    ...baseStyles,
    color: "#BC865380",
  }),
  dropdownIndicator: (baseStyles) => ({
    ...baseStyles,
    color: "#BC865399",
    "&:hover": {
      color: "#BC865399",
      cursor: "pointer",
    },
  }),
  indicatorSeparator: (baseStyles) => ({
    ...baseStyles,
    backgroundColor: "#BC865399",
  }),
  noOptionsMessage: (baseStyles) => ({
    ...baseStyles,
    color: "#BC865380",
  }),
  option: (baseStyles, state) => ({
    ...baseStyles,
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    backgroundColor: state.isSelected ? "#BC8653" : "",
    color: state.isSelected ? "#F4F7FA" : "#233E5A",
    "&:hover": {
      color: "#F4F7FA",
      backgroundColor: "#BC865380",
      cursor: "pointer",
    },
  }),
};
export const customErrorStyles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    border: "1px solid #dc3545",
    borderRadius: "6px",
    boxShadow: state.isFocused ? "0 0 0 .25rem #BC865380" : "",
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    color: "#233E5A",
    padding: "4px 0",
    marginTop: "6px",
    "&:hover": {
      border: "1px solid #BC865399",
    },
  }),
  input: (baseStyles) => ({
    ...baseStyles,
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    color: "#233E5A",
  }),
  placeholder: (baseStyles) => ({
    ...baseStyles,
    color: "#BC865380",
  }),
  dropdownIndicator: (baseStyles) => ({
    ...baseStyles,
    color: "#BC865399",
    "&:hover": {
      color: "#BC865399",
      cursor: "pointer",
    },
  }),
  indicatorSeparator: (baseStyles) => ({
    ...baseStyles,
    backgroundColor: "#BC865399",
  }),
  noOptionsMessage: (baseStyles) => ({
    ...baseStyles,
    color: "#BC865380",
  }),
  option: (baseStyles, state) => ({
    ...baseStyles,
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    backgroundColor: state.isSelected ? "#BC8653" : "",
    color: state.isSelected ? "#F4F7FA" : "#233E5A",
    "&:hover": {
      color: "#F4F7FA",
      backgroundColor: "#BC865380",
      cursor: "pointer",
    },
  }),
};
